import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ConvexProvider, ConvexReactClient } from "convex/react";
import { ClerkProvider, useAuth } from "@clerk/clerk-react";
import { ConvexProviderWithClerk } from "convex/react-clerk";
import "../index.css";
import { CONVEX_URL } from "../lib/convex";
import { config } from "../lib/config";
import { App } from "../App";

const convex = new ConvexReactClient(CONVEX_URL);
const clerkKey = config.clerkPublishableKey;

const elem = document.getElementById("root")!;

function AppWithAuth() {
  return (
    <ClerkProvider publishableKey={clerkKey}>
      <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
        <App />
      </ConvexProviderWithClerk>
    </ClerkProvider>
  );
}

function AppWithoutAuth() {
  return (
    <ConvexProvider client={convex}>
      <App />
    </ConvexProvider>
  );
}

const Root = clerkKey ? AppWithAuth : AppWithoutAuth;

const app = (
  <StrictMode>
    <Root />
  </StrictMode>
);

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  createRoot(elem).render(app);
}
